export const WORKFLOWS_OPTIONS = Object.freeze([
	{
		label: 'Dictionary',
		value: 'dictionary',
	},
]);
